// Keyword-rich, human-readable intro — helps SEO for Dora's target terms
// while reading naturally to visitors.
export default function SeoIntro() {
    return (
        <section data-testid="home-seo-intro" className="border-t border-amber-500/10 bg-[#140d08] px-6 py-16">
            <div className="mx-auto max-w-3xl text-center">
                <p className="text-xs uppercase tracking-[0.25em] text-amber-400/70">A warm space for healing</p>
                <h2 className="mt-4 font-serif text-2xl text-amber-50 sm:text-3xl">
                    Play therapy, trauma therapy &amp; therapist training in Longwood, Florida
                </h2>
                <p className="mt-5 text-sm leading-relaxed text-amber-100/70 sm:text-base">
                    NeuroPlay Counseling, LLC is
                    a warm, neuroscience-informed practice led by <span className="text-amber-200">Dora Henderson</span>{" "}
                    (LMHC-QS, RPT-S) and <span className="text-amber-200">Ryan Uner</span> (LMHC). We offer play
                    therapy, EMDR and trauma-informed therapy for children, teens and adults, along with
                    neuropsychology-based therapist training and continuing education for fellow counselors.
                    Whether you're seeking a brilliant, compassionate therapist for your family, support through a
                    mental-health crisis, or a warm space to begin healing, you're welcome here.
                </p>
                <p className="mt-4 text-xs leading-relaxed text-amber-100/45">
                    Serving Longwood and Central Florida with counseling, psychology-informed care, play therapy,
                    NeuroPlay and safe, judgment-free mental-health support.
                </p>
            </div>
        </section>
    );
}
